export class HealthCareService {
    id = null;
    name = null;
    code = null;
    serviceType = {
        code: null,
        name: null,
        description: null,
    };
    isDefault = null;
    isIndependent = true;//type: xet nghiem - Neu bang false thi bat buoc phai chon trong 1 Set 
    insuranceLimit = null; //han muc bao hiem chi tra
    itemDataType = null; //muc dich hien thi
}

export class HealthCareRole {
    name = null;
    code = null;
    wageValue = null;
    wageType = null;// 1. phan tran 2. co dinh
    service = null;
    serviceRole = null;
}